export default __webpack_public_path__ + "/dist/images/travel-contentimg.02e456ae4c4d78ad4f2d2da1ed476c46.png";